import { PDF_CONTENT_HEIGHT_PX, PDF_SECTION_GAP_PX } from "./pdfDimensions";

/** Pack section indices into pages by measured height (greedy first-fit). */
export function packPdfUnits(
  heights: number[],
  maxHeight: number = PDF_CONTENT_HEIGHT_PX,
  gap: number = PDF_SECTION_GAP_PX,
): number[][] {
  if (heights.length === 0) {
    return [];
  }

  const pages: number[][] = [];
  let current: number[] = [];
  let used = 0;

  for (let i = 0; i < heights.length; i += 1) {
    const h = Math.max(0, Math.ceil(heights[i]));

    if (h > maxHeight) {
      if (current.length > 0) {
        pages.push(current);
        current = [];
        used = 0;
      }
      pages.push([i]);
      continue;
    }

    const extraGap = current.length > 0 ? gap : 0;

    if (used + extraGap + h <= maxHeight) {
      used += extraGap + h;
      current.push(i);
    } else {
      if (current.length > 0) {
        pages.push(current);
      }
      current = [i];
      used = h;
    }
  }

  if (current.length > 0) {
    pages.push(current);
  }

  return pages;
}
